import(/* webpackMode: "eager" */ "/work/apps/dashboard/src/app/page.tsx");
